export const DEFAULT_BORDER_COLOR = '#ccd3da';
